export default __webpack_public_path__ + "static/FacePainting1-3ac3602c9588c28b1389b61ff41ab0d8.png";